// LoginPage.js

import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  Card,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "shards-react";
import illustration from "../images/restaurant_illustration.png";
import "./LoginPage.css";
import { strings } from "../localization";
import {
  CUSTOMER_EMAIL,
  CUSTOMER_ID,
  emailRegxPattern,
  getLogoUrl,
  getOrganisationId,
  getPlatform,
  navigatePage,
  ORG_ID,
  ROUTE_PREFIX,
  TABLE_ID,
} from "../config";
import { registerDevice, signUp } from "../api/ApiServices";
import { withRouter } from "react-router-dom";
import { getFCMToken } from "../utils/firebaseUtils";

const LoginPage = ({ match, location }) => {
  const { restaurantName } = match.params || {};
  const params = new URLSearchParams(location.search);
  const [organisationId, setOrganisationId] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [logoImg, setLogoImg] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      displayInputError(strings.email_require_err_msg);
    } else if (email && !emailRegxPattern.test(email)) {
      displayInputError(strings.email_valid_error);
    } else {
      setIsBtnLoading(true);
      const bodyData = {
        email,
        organisationID: organisationId,
      };
      signUp(bodyData)
        .then(async (res) => {
          console.log("response of sign up api", res);
          const parsedData = await res.json();
          if (res.status === 200) {
            setError("");
            localStorage.setItem(CUSTOMER_EMAIL, email);
            if (parsedData) {
              localStorage.setItem(ORG_ID, organisationId);
              localStorage.setItem(CUSTOMER_ID, parsedData._id);
            }
            const permission = await Notification.requestPermission();
            const fcmToken = await getFCMToken();
            console.log("fcmToken : ", fcmToken);
            if (fcmToken) {
              registerDevice()
                .then((res) => {
                  console.log("register device api response", res);
                  navigatePage(`/${ROUTE_PREFIX}${restaurantName}/home`);
                  setIsBtnLoading(false);
                })
                .catch((err) => {
                  console.log("error", err);
                  navigatePage(`/${ROUTE_PREFIX}${restaurantName}/home`);
                  setIsBtnLoading(false);
                });
            } else {
              navigatePage(`/${ROUTE_PREFIX}${restaurantName}/home`);
              setIsBtnLoading(false);
            }
          } else {
            setIsBtnLoading(false);
          }
        })
        .catch((err) => {
          console.log("sign up catch block error", err);
          setIsBtnLoading(false);
        });
    }
  };

  const displayInputError = (msg) => {
    setError(msg);

    setTimeout(() => {
      setError("");
    }, [3000]);
  };

  const getInitialData = () => {
    const orgId = getOrganisationId();
    const logoURl = getLogoUrl();
    setOrganisationId(orgId);
    setLogoImg(logoURl);
  };

  useEffect(() => {
    getInitialData();
  }, []);

  return (
    <>
      <Container fluid className="login-page-container">
        <Row className="login-content">
          {/* Shared Layout for Both Views */}
          <Col md={6} className="left-content">
            <div className="logo-wrapper text-center text-md-left mb-2">
              {/* <img src={getLogoUrl()} alt="Logo" className="logo-img" /> */}
              {logoImg && (
                <img
                  src={`data:image/png;base64,${logoImg}`}
                  alt="Logo"
                  height="30"
                />
              )}
            </div>

            {/* Mobile Only Illustration */}
            <div className="d-block d-md-none mobile-illustration-container">
              <img
                src={illustration}
                alt="Illustration"
                className="mobile-illustration"
              />
            </div>

            {/* Desktop Form */}
            <div className="d-none d-md-block form-wrapper">
              <Card className="p-4 form-card">
                <h2 className="mb-2">{strings.login_title}</h2>
                <p className="text-muted mb-3">{strings.login_desc}</p>
                <LoginFormComponent
                  email={email}
                  setEmail={setEmail}
                  error={error}
                  handleSubmit={handleSubmit}
                  isLoading={isBtnLoading}
                />
              </Card>
            </div>
          </Col>

          {/* Desktop Illustration */}
          <Col
            md={6}
            className="d-none d-md-flex justify-content-center align-items-center right-content"
          >
            <img
              src={illustration}
              alt="Illustration"
              className="desktop-illustration"
            />
          </Col>
        </Row>

        {/* Mobile Fixed Form */}
        <div className="mobile-form-fixed d-md-none">
          <Card className="p-3 form-card mb-0">
            <h2 className="mb-2">{strings.login_title}</h2>
            <p className="text-muted mb-3">{strings.login_desc}</p>
            <LoginFormComponent
              email={email}
              setEmail={setEmail}
              error={error}
              handleSubmit={handleSubmit}
              isLoading={isBtnLoading}
            />
          </Card>
        </div>
      </Container>
    </>
  );
};

export default withRouter(LoginPage);

export const LoginFormComponent = ({
  error,
  email,
  setEmail,
  handleSubmit,
  isLoading,
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group mt-3">
        <label>{strings.email}</label>
        <InputGroup seamless className="mb-1" style={{ borderColor: "red" }}>
          <InputGroupAddon type="prepend">
            <InputGroupText>
              <i className="material-icons">email</i>
            </InputGroupText>
          </InputGroupAddon>
          {error && (
            <InputGroupAddon type="append">
              <InputGroupText>
                <i className="material-icons text-danger">warning</i>
              </InputGroupText>
            </InputGroupAddon>
          )}
          <input
            type="email"
            className="form-control textBox"
            placeholder={strings.enter_email}
            value={email}
            style={{ borderColor: error ? "red " : "" }}
            onChange={(e) => setEmail(e.target.value)}
          />
        </InputGroup>
        <p
          style={{
            color: error ? "red" : "transparent",
          }}
        >
          {error}
        </p>
      </div>

      <button
        type="button"
        className="btn btn-primary btn-block w-100 mt-2"
        onClick={(e) => handleSubmit(e)}
      >
        {isLoading ? (
          <i
            className={"fa fa-spinner fa-spin"}
            style={{ fontSize: "16px", fontWeight: "bold", color: "white" }}
          ></i>
        ) : (
          strings.login_title
        )}
      </button>
    </form>
  );
};
